export const colorPallet = {
    orange:'#e78b00',
    brown:'#ae8a68',
    tan:'#fff7e9',
    gray:'#dfe0df'
}